import { type IReference } from '../../../../expressions/references/IReference.ts';
import { type WidgetType } from '../../../Widget.ts';
import { type IInputWidget } from '../../inputs/IInputWidget.ts';

export interface IRepeatControllerWidget extends IInputWidget {
  type: WidgetType.RepeatController;
  kind: RepeatControllerComponentType;
  listReference: IReference;
  confirmReduce: boolean;
}

/**
 * Indica se il widget è un input (campo modificabile da utente)
 * oppure calcolato (il valore dipende da una formula)
 */
export enum RepeatControllerComponentType {
  Input = 'input',
}
